import { motion, AnimatePresence } from 'framer-motion';

interface HeroOverlayProps {
  visible: boolean;
}

const stats = [
  'Kubernetes · ArgoCD · GitOps',
  'Azure AZ-104 / AZ-400 in prep',
  '3+ yrs production experience',
];

export default function HeroOverlay({ visible }: HeroOverlayProps) {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6 }}
          className="fixed inset-0 z-10 pointer-events-none"
        >
          {/* Hero column — left on desktop, top-center on mobile */}
          <div
            className="absolute inset-x-0 top-16 px-6 flex justify-center
                       md:inset-x-auto md:inset-y-0 md:top-0 md:left-[7%] md:px-0
                       md:items-center md:justify-start"
          >
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            className="text-center md:text-left md:max-w-md"
          >
            <div className="text-[11px] font-mono uppercase tracking-[0.3em] text-cyan-400/70 mb-4">
              Lehlogonolo Theledi
            </div>
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-4 leading-[1.05]">
              <span className="bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-500 bg-clip-text text-transparent">
                DevOps
              </span>
              <br />
              <span className="text-white/90">Engineer</span>
            </h1>
            <p className="text-gray-400 text-[13px] font-mono tracking-wide leading-relaxed">
              Kubernetes · GitOps · Cloud Infrastructure
            </p>

            <div
              className="hidden md:block h-px w-24 my-6"
              style={{ background: 'linear-gradient(to right, rgba(0,240,255,0.5), transparent)' }}
            />

            <motion.ul
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.8 }}
              className="hidden md:block space-y-2"
            >
              {stats.map((stat) => (
                <li key={stat} className="flex items-center gap-2.5 text-gray-500 text-xs">
                  <span className="w-1 h-1 rounded-full bg-cyan-400/60 flex-shrink-0" />
                  {stat}
                </li>
              ))}
            </motion.ul>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1.2 }}
              className="mt-8 flex items-center justify-center md:justify-start gap-2
                         text-gray-600 text-xs font-mono"
            >
              <div className="w-1 h-1 rounded-full bg-cyan-400 animate-pulse" />
              Click a marker to explore
            </motion.div>
          </motion.div>
          </div>

          {/* Corner HUD */}
          <div className="absolute top-6 left-6 text-[10px] font-mono text-gray-700 hidden sm:block">
            <div>SYS.ONLINE</div>
            <div className="text-cyan-500/40 mt-1">v1.0.0</div>
          </div>
          <div className="absolute top-6 right-6 text-[10px] font-mono text-gray-700 text-right hidden sm:block">
            <div>LAT 0.00 / LON 0.00</div>
            <div className="text-cyan-500/40 mt-1">ORBIT.STABLE</div>
          </div>

          {/* Footer */}
          <div className="absolute bottom-6 left-6 text-[10px] font-mono text-gray-700 hidden md:block">
            © 2026 Lehlogonolo Theledi · Pretoria, ZA · Remote
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
